import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69d66efba749570014ed29c4/basecamp_1775660795663/src/app/home/page.tsx");
